import "./App.css";
import { useLocation } from "react-router-dom";
import Layout from "./Components/Layout";
import RouteComponent from "./Router/RouteComponent";
import { RoutesPaths } from "./Router/constant";

// Auth screens own the full viewport, so the app chrome stays hidden there.
const AUTH_ROUTES = [RoutesPaths.LOGIN, RoutesPaths.VERIFY_OTP];

function App() {
  const { pathname } = useLocation();

  if (AUTH_ROUTES.includes(pathname)) {
    return <RouteComponent />;
  }

  return (
    <Layout>
      <RouteComponent />
    </Layout>
  );
}

export default App;
